var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.13,
    y: 100.32,
    width: 1.8,
    height: 140.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.18,
    y: 100.32,
    width: 1.8,
    height: 140.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 109.15 72.08 109.15 69.38 102.85 202.73 102.85 200.03 109.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 117.8 72.08 117.8 69.38 111.5 202.73 111.5 200.03 117.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 126.45 72.08 126.45 69.38 120.15 202.73 120.15 200.03 126.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 135.1 72.08 135.1 69.38 128.8 202.73 128.8 200.03 135.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 143.75 72.08 143.75 69.38 137.45 202.73 137.45 200.03 143.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 152.4 72.08 152.4 69.38 146.1 202.73 146.1 200.03 152.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 161.05 72.08 161.05 69.38 154.75 202.73 154.75 200.03 161.05",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 169.7 72.08 169.7 69.38 163.4 202.73 163.4 200.03 169.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 178.34 72.08 178.34 69.38 172.04 202.73 172.04 200.03 178.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 186.99 72.08 186.99 69.38 180.69 202.73 180.69 200.03 186.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 195.64 72.08 195.64 69.38 189.34 202.73 189.34 200.03 195.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 204.29 72.08 204.29 69.38 197.99 202.73 197.99 200.03 204.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 212.94 72.08 212.94 69.38 206.64 202.73 206.64 200.03 212.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 221.59 72.08 221.59 69.38 215.29 202.73 215.29 200.03 221.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 230.24 72.08 230.24 69.38 223.94 202.73 223.94 200.03 230.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.03 238.89 72.08 238.89 69.38 232.59 202.73 232.59 200.03 238.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.38,
    y: 238.89,
    width: 133.35,
    height: 3.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.73,
    y: 94.96,
    width: 142.65,
    height: 8.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.19,179.52h0a1.45,1.45,0,0,1-1.45-1.45v-49a1.45,1.45,0,0,1,1.45-1.45h0a1.45,1.45,0,0,1,1.45,1.45v49A1.45,1.45,0,0,1,66.19,179.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.67,
    y: 101.68,
    width: 1.05,
    height: 29.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.43,
    y: 124.56,
    width: 107.89,
    height: 256.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.01,
    y: 129.2,
    width: 98.72,
    height: 251.45,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.48,
    y: 274.64,
    width: 84.3,
    height: 92.09,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.48,
    y: 140.55,
    width: 84.3,
    height: 92.09,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.75,
    y: 241.9,
    width: 9.34,
    height: 24.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.09,
    y: 241.9,
    width: 1.84,
    height: 24.34,
    transform: "translate(702.02 508.14) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,251.46a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,347,251.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.22,
    y: 258.27,
    width: 2.03,
    height: 4.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.84,251.46c0,1.34-11.63,2.42-13,2.42a2.42,2.42,0,0,1,0-4.84C344.21,249,355.84,250.13,355.84,251.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.09,
    cy: 95.26,
    r: 20.73,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.7,
    cy: 94.39,
    r: 20.73,
    transform: "translate(224.87 453.08) rotate(-80.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.34,94.53A16.64,16.64,0,1,1,378.7,77.89,16.64,16.64,0,0,1,395.34,94.53Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.8,96.1a1.69,1.69,0,0,1,0-2.39,1.71,1.71,0,0,1,2.39,0,1.69,1.69,0,1,1-2.39,2.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.69 94.33 388.52 94.03 388.55 95.05 379.65 95.32 378.69 110.8 377.68 110.74 378.69 94.33",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-43"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-43",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,404.59c0-.34-3.54-34.42,4.28-63.41l1,.26C83.52,370.25,87,404.15,87,404.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.48,348.53s-10.77,20-8.62,43.57C85.86,392.1,90.34,363.14,94.48,348.53Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.07,338.63s15.72,22.11,13,50.34C86.05,389,79.94,353.5,73.07,338.63Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,395.79s3.4-29.19-14.66-37.62C71.29,358.17,80.92,365.29,86,395.79Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.85,341.63l-.33.06a.87.87,0,0,0-.68,1.1l.4,1.45a.87.87,0,0,0,1.45.39l.54-.52a.88.88,0,0,1,1.43.33l.73,2a.87.87,0,0,0,1.27.45l1.68-1a.87.87,0,0,0,.18-1.35l-.27-.28a.88.88,0,0,1,.61-1.48l1.46,0a.87.87,0,0,0,.84-1L97,340.53a.87.87,0,0,0-1.25-.67l-.1.05a.88.88,0,0,1-1.18-1.14l.48-1.1a.87.87,0,0,0-.69-1.21l-1.55-.21a.87.87,0,0,0-1,.84h0a.88.88,0,0,1-1.64.4l-.2-.36a.88.88,0,0,0-1.36-.21L87.36,338a.88.88,0,0,0,0,1.28l.92.85A.88.88,0,0,1,87.85,341.63Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.85,341.63l-.33.06a.87.87,0,0,0-.68,1.1l.4,1.45a.87.87,0,0,0,1.45.39l.54-.52a.88.88,0,0,1,1.43.33l.73,2a.87.87,0,0,0,1.27.45l1.68-1a.87.87,0,0,0,.18-1.35l-.27-.28a.88.88,0,0,1,.61-1.48l1.46,0a.87.87,0,0,0,.84-1L97,340.53a.87.87,0,0,0-1.25-.67l-.1.05a.88.88,0,0,1-1.18-1.14l.48-1.1a.87.87,0,0,0-.69-1.21l-1.55-.21a.87.87,0,0,0-1,.84h0a.88.88,0,0,1-1.64.4l-.2-.36a.88.88,0,0,0-1.36-.21L87.36,338a.88.88,0,0,0,0,1.28l.92.85A.88.88,0,0,1,87.85,341.63Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.29,388.28l1.26-9.75h-11l1.25,9.75A13.05,13.05,0,0,0,72,400.6a21.57,21.57,0,0,0,2.14,8.69,7.62,7.62,0,0,0,6.93,4.34h8a7.59,7.59,0,0,0,6.92-4.34,21.43,21.43,0,0,0,2.15-8.69A13,13,0,0,0,89.29,388.28Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.29,388.28l1.26-9.75h-11l1.25,9.75A13.05,13.05,0,0,0,72,400.6a21.57,21.57,0,0,0,2.14,8.69,7.62,7.62,0,0,0,6.93,4.34h8a7.59,7.59,0,0,0,6.92-4.34,21.43,21.43,0,0,0,2.15-8.69A13,13,0,0,0,89.29,388.28Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--layer-9--inject-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "307.93 293.51 307.93 413.02 311.19 413.02 314.09 299.62 317.93 299.62 317.93 293.51 307.93 293.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.82 413.02 313.93 413.02 317.93 293.52 313.82 293.52 310.82 413.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "311.42 413.02 313.93 413.02 317.65 299.76 314.14 299.76 311.42 413.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "307.93 293.51 307.93 413.02 311.19 413.02 314.09 299.62 317.93 299.62 317.93 293.51 307.93 293.51",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.16 413.02 115.27 413.02 119.27 293.68 115.16 293.68 112.16 413.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.16 413.02 115.27 413.02 119.27 293.68 115.16 293.68 112.16 413.02",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.27 293.68 162.27 413.02 158.98 413.02 155.11 299.47 115.42 299.47 112.52 413.02 109.27 413.02 109.27 293.68 162.27 293.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.27 293.68 162.27 413.02 158.98 413.02 155.11 299.47 115.42 299.47 112.52 413.02 109.27 413.02 109.27 293.68 162.27 293.68",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.27 413.02 165.37 413.02 166.37 293.68 162.27 293.68 162.27 413.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.27 413.02 165.37 413.02 166.37 293.68 162.27 293.68 162.27 413.02",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.93 293.68 317.93 299.48 353.77 299.48 357.64 413.02 360.93 413.02 360.93 293.68 317.93 293.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.93 293.68 317.93 299.48 353.77 299.48 357.64 413.02 360.93 413.02 360.93 293.68 317.93 293.68",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.93 293.68 317.93 299.48 353.77 299.48 357.64 413.02 360.93 413.02 360.93 293.68 317.93 293.68",
    style: {
      fill: "none",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.93 413.02 364.04 413.02 365.04 293.68 360.93 293.68 360.93 413.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "360.93 413.02 364.04 413.02 365.04 293.68 360.93 293.68 360.93 413.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 164.83,
    y: 285.98,
    width: 205.65,
    height: 7.67,
    transform: "translate(535.31 579.62) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.83,
    y: 285.98,
    width: 205.65,
    height: 7.67,
    transform: "translate(535.31 579.62) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.83,
    y: 285.98,
    width: 65.78,
    height: 7.67,
    transform: "translate(273.44 579.62) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.83,
    y: 285.98,
    width: 65.78,
    height: 7.67,
    transform: "translate(273.44 579.62) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58,283.86v1.06a1,1,0,0,0,1,1h38a.92.92,0,0,0,.92-.91v-1a.92.92,0,0,0-.92-.92h-9.45a1.73,1.73,0,0,1-1.71-2l3.32-19.16h-21.6l-9.25,20.46A3.81,3.81,0,0,0,149.58,283.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.51,284v1a.91.91,0,0,1-.91.91h-38a1,1,0,0,1-1-1v-1.06a4,4,0,0,1,.1-.84,4.3,4.3,0,0,1,.23-.69l9.25-20.46h21.6L177.43,281a1.32,1.32,0,0,0,0,.34,1.72,1.72,0,0,0,1.37,1.65,1.42,1.42,0,0,0,.36,0h9.46A.91.91,0,0,1,189.51,284Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.68,282.33l9.25-20.46h1.22l-9.25,20.46a3.81,3.81,0,0,0-.32,1.53v1.06a1,1,0,0,0,1,1h-1.22a1,1,0,0,1-1-1v-1.06A3.82,3.82,0,0,1,148.68,282.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.15 261.87 180.75 261.87 179.9 266.76 156.94 266.76 159.15 261.87",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,264H124.85a3.37,3.37,0,0,1-3.37-3.37V194.06a3.37,3.37,0,0,1,3.37-3.37H217a3.37,3.37,0,0,1,3.37,3.37v66.59A3.37,3.37,0,0,1,217,264Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217,264H124.85a3.37,3.37,0,0,1-3.37-3.37V194.06a3.37,3.37,0,0,1,3.37-3.37H217a3.37,3.37,0,0,1,3.37,3.37v66.59A3.37,3.37,0,0,1,217,264Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 123.08,
    y: 192.73,
    width: 95.68,
    height: 58.69,
    rx: 1.83,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.08,
    y: 192.73,
    width: 95.68,
    height: 58.69,
    rx: 1.83,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.81,190.69h2a3.37,3.37,0,0,0-3.37,3.37v66.59a3.37,3.37,0,0,0,3.37,3.37h-2a3.37,3.37,0,0,1-3.37-3.37V194.06A3.37,3.37,0,0,1,122.81,190.69Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.81,190.69h2a3.37,3.37,0,0,0-3.37,3.37v66.59a3.37,3.37,0,0,0,3.37,3.37h-2a3.37,3.37,0,0,1-3.37-3.37V194.06A3.37,3.37,0,0,1,122.81,190.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "162.85 192.73 159.31 192.73 141.7 251.41 145.24 251.41 162.85 192.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.12 251.41 155.73 192.73 142.43 192.73 124.82 251.41 138.12 251.41",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.15,284v1a1,1,0,0,0,.95,1h31.5a.91.91,0,0,0,.91-.91v-1a.92.92,0,0,0-.91-.92h-9.46a1.47,1.47,0,0,1-.36,0H157.1A1,1,0,0,0,156.15,284Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.67,283h29.11a1.71,1.71,0,0,1-1.37-1.65h-27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,283.6h2.76a.5.5,0,0,0,.52-.48v-2.66a.5.5,0,0,0-.52-.48h-2a.52.52,0,0,0-.51.36l-.77,2.65A.49.49,0,0,0,221.78,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,283.6h2.75a.51.51,0,0,0,.53-.48v-2.66a.51.51,0,0,0-.53-.48h-2a.52.52,0,0,0-.51.36l-.78,2.65A.49.49,0,0,0,218,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.17,283.6h2.76a.5.5,0,0,0,.52-.48v-2.66a.5.5,0,0,0-.52-.48h-2a.52.52,0,0,0-.51.36l-.77,2.65A.49.49,0,0,0,214.17,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,283.6h2.75a.51.51,0,0,0,.53-.48v-2.66a.51.51,0,0,0-.53-.48h-2a.52.52,0,0,0-.51.36l-.78,2.65A.49.49,0,0,0,210.37,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,283.6h2.76a.5.5,0,0,0,.52-.48v-2.66a.5.5,0,0,0-.52-.48h-2a.52.52,0,0,0-.51.36l-.77,2.65A.49.49,0,0,0,206.56,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,283.6h2.75a.51.51,0,0,0,.53-.48v-2.66a.51.51,0,0,0-.53-.48h-2a.52.52,0,0,0-.51.36l-.78,2.65A.49.49,0,0,0,202.76,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,283.6h2.76a.5.5,0,0,0,.52-.48v-2.66a.5.5,0,0,0-.52-.48h-2a.52.52,0,0,0-.51.36l-.77,2.65A.49.49,0,0,0,199,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.15,283.6h2.75a.51.51,0,0,0,.53-.48v-2.66a.51.51,0,0,0-.53-.48h-2a.52.52,0,0,0-.51.36l-.78,2.65A.49.49,0,0,0,195.15,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.34,283.6h2.76a.5.5,0,0,0,.52-.48v-2.66a.5.5,0,0,0-.52-.48h-2a.52.52,0,0,0-.51.36l-.77,2.65A.49.49,0,0,0,191.34,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.54,283.6h2.75a.51.51,0,0,0,.53-.48v-2.66a.51.51,0,0,0-.53-.48h-2a.52.52,0,0,0-.5.36L187,283A.49.49,0,0,0,187.54,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.73,283.6h2.76a.5.5,0,0,0,.52-.48v-2.66a.5.5,0,0,0-.52-.48h-2a.52.52,0,0,0-.51.36l-.77,2.65A.49.49,0,0,0,183.73,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.93,283.6h2.75a.51.51,0,0,0,.53-.48v-2.66a.51.51,0,0,0-.53-.48h-2a.52.52,0,0,0-.5.36l-.78,2.65A.49.49,0,0,0,179.93,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.12,283.6h2.76a.5.5,0,0,0,.52-.48v-2.66a.5.5,0,0,0-.52-.48h-2a.52.52,0,0,0-.51.36l-.77,2.65A.49.49,0,0,0,176.12,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,283.6h2.75a.51.51,0,0,0,.53-.48v-2.66a.51.51,0,0,0-.53-.48h-2a.52.52,0,0,0-.5.36l-.78,2.65A.49.49,0,0,0,172.32,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.51,283.6h2.76a.5.5,0,0,0,.52-.48v-2.66a.5.5,0,0,0-.52-.48h-2a.52.52,0,0,0-.51.36L168,283A.49.49,0,0,0,168.51,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.74,283.88A2.2,2.2,0,0,0,168,286h57a2.2,2.2,0,0,0,2.29-2.09,2,2,0,0,0-.67-1.48,2.42,2.42,0,0,0-1.57-.61H168a2.59,2.59,0,0,0-.63.08A2.14,2.14,0,0,0,165.74,283.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.74,283.88A2.2,2.2,0,0,0,168,286h57a2.2,2.2,0,0,0,2.29-2.09,2,2,0,0,0-.67-1.48,2.42,2.42,0,0,0-1.57-.61H168a2.59,2.59,0,0,0-.63.08A2.14,2.14,0,0,0,165.74,283.88Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.74,283.88A2.2,2.2,0,0,0,168,286h19.29a2.11,2.11,0,0,0,1.59-2,2.22,2.22,0,0,0,0-.37,2.06,2.06,0,0,0-.64-1.11,3.3,3.3,0,0,0-.49-.34l-.27-.12a2.37,2.37,0,0,0-.88-.16H167.4A2.14,2.14,0,0,0,165.74,283.88Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.73,245.48s7.36,91.55,7.42,92.07l4.66,54.58h10.13s.31-2.93.94-7.07c5.52-36.29,1.6-48.23,1.6-48.23s4.86-70.06,6.56-75.34C376.21,260.94,370.51,222.49,344.73,245.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344.73,245.48s7.36,91.55,7.42,92.07l4.66,54.58h10.13s.31-2.93.94-7.07c5.52-36.29,1.6-48.23,1.6-48.23s4.86-70.06,6.56-75.34C376.21,260.94,370.51,222.49,344.73,245.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M344.79,244.21h0a32.66,32.66,0,0,0,14.09,19.09l7,4.43s36.43-35.11,4.46-42.81C364.15,223.43,344.79,244.21,344.79,244.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.1 383.17 429.74 387.46 423.79 379.82 417.35 371.55 417.35 371.54 424.83 366.41 425.85 367.92 430.86 375.38 436.1 383.17",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.86 375.38 423.79 379.82 417.35 371.55 425.01 366.74 425.85 367.92 430.86 375.38",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.07,279.57c.15,12.09,2.78,33.93,4.45,45.9,0,0,9,10.73,13.93,18.17L428,369.17l-9.56,6.2L388,342.57c-8.72-6.62-7.32-10.62-9.53-16.68-5.41-14.8-8.89-30.75-11.27-45.2-1.1-6.7-5.93-28.47-4.25-35,2.26-8.84,4.89-24.06,15.26-17.51C386.9,233.64,393.63,242.59,394.07,279.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.56 371.69 419.74 379.14 414.94 374.2 428.23 365.7 431.56 371.69",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.49,387.73l4.81-8.43a.66.66,0,0,1,.85-.31l7.2,2.83a1.39,1.39,0,0,1,.73,1.82l-.07.13c-1.73,2.91-2.7,4.22-4.81,7.92-1.29,2.28-3.82,7.49-5.61,10.64s-5,1.54-4.53.07c2.08-6.58,1.75-10.27,1.21-13.19A2.18,2.18,0,0,1,428.49,387.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.13,392.24c1-.35,1.76-2.25,2.06-3.34a.2.2,0,0,0-.07-.21.18.18,0,0,0-.22,0c-.32.17-3.07,1.61-3.17,2.69a.71.71,0,0,0,.29.65,1.69,1.69,0,0,0,.29.17A1.06,1.06,0,0,0,427.13,392.24Zm1.53-3c-.5,1.45-1.09,2.41-1.65,2.59a.8.8,0,0,1-.74-.18.25.25,0,0,1-.13-.27c.05-.58,1.43-1.53,2.52-2.14Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.1,389a.22.22,0,0,0,.1-.18.2.2,0,0,0-.12-.16c-.09-.06-2.25-1.27-3.43-.87a1.06,1.06,0,0,0-.65.61.72.72,0,0,0,.15.88,1.2,1.2,0,0,0,.21.13A5.4,5.4,0,0,0,429.1,389Zm-.55-.18c-1,.38-2.68.54-3.13.15-.07-.07-.15-.17-.05-.41a.68.68,0,0,1,.42-.39,4.67,4.67,0,0,1,2.7.62Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.66,281.35l-6.72-.43s-4.71-33.86-5.16-35.21c-.62-2.46-4.39-21.34-5.88-26.16l.72-.11c-.8-2.48-.12-5.16,2.49-6s6.19.54,7,3c1.68,5,4.88,24,5.36,26.28a.88.88,0,0,1,0,.16C324,252.79,324.66,281.35,324.66,281.35Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.66,281.35c0,3.08-2.8,4.67-4.82,4.88H309.18l-.62-.15a.35.35,0,0,1-.14-.6l1.92-1.54c2.12-1.71,5-2.27,7.6-3Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.59,203.12c-10.91,5.25-3.29,27.12-3.29,27.12L321.71,229s1.33-15.86-.19-20.81C319.91,203,316.81,199.71,311.59,203.12Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.63,229.55s-3-16-.06-19a8.76,8.76,0,0,1,2.87-1.42c3.59,1.55,2.85,6.72,2.85,6.72l.42,13.13C320,229.25,315.63,229.55,315.63,229.55Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,217.07c3.5,6.07,11,14.2,31,26.71l24.66-19c-8.29-9.91-13.46-16.51-23.58-37.9a7.6,7.6,0,0,0-5.09-4.23,7.5,7.5,0,0,0-5.48.83c-1.83,1.07-3.82,2.3-5.76,3.66a110.08,110.08,0,0,0-12.58,9.68c-2.76,2.55-5.52,5.47-7.49,7.61,0,0,0,.34.16,1.13A34.71,34.71,0,0,0,313.64,217.07Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.22,189.09c.33.85.66,1.71,1,2.46a101.64,101.64,0,0,0,5.63,11.36c-8,1.42-16.18-3-17.39-5.88C335.69,195.28,343.22,190.26,347.22,189.09Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.45,222.84l3.15,1.51c.25.12.2.49-.15.74l-26.72,20.39c-.25.19-.56.22-.69.08l-2.16-2.29c-.15-.15,0-.46.23-.68L367.83,223A.64.64,0,0,1,368.45,222.84Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.45,222.84l3.15,1.51c.25.12.2.49-.15.74l-26.72,20.39c-.25.19-.56.22-.69.08l-2.16-2.29c-.15-.15,0-.46.23-.68L367.83,223A.64.64,0,0,1,368.45,222.84Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,242.59,367.83,223",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.08,228.86l.72-.57c.16-.11.21-.28.13-.36l-2.84-3c-.08-.09-.27-.07-.42.05l-.72.56c-.15.12-.2.28-.12.37l2.83,2.95A.32.32,0,0,0,367.08,228.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.09,244.14l.72-.57c.15-.11.21-.28.12-.37l-2.83-2.94a.34.34,0,0,0-.43.05l-.72.56c-.15.12-.21.29-.13.37l2.84,2.95C346.74,244.28,346.93,244.26,347.09,244.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,173.92c2.33,4.66,7.24,12.69,12.15,13.22,0,0,2.86,7.05-2.5,20.08-11.58-2.47-10.08-10.4-10.08-10.4,3.69-4.56,1-7.81-2.22-10.35Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.68,208.74l.41-1c5.5-13.38,2.68-21.14,2.55-21.45l-2.8.47.3.88c0,.07,2.41,6.44-2.07,18-8.95-2.37-8.43-9.88-8.38-10.14l-2,2.21c0,.09-1.83,8.06,10.87,10.77Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.68,208.74l.41-1c5.5-13.38,2.68-21.14,2.55-21.45l-2.8.47.3.88c0,.07,2.41,6.44-2.07,18-8.95-2.37-8.43-9.88-8.38-10.14l-2,2.21c0,.09-1.83,8.06,10.87,10.77Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.93,175.29a21.28,21.28,0,0,1,3.67,8.24c.41,2.06-.79,6.27-3,6a14,14,0,0,0-3-3.08Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.29,197.51c-9.28-7.71-11.9-18.41-12-27.95,0-1.8.37-7.61,2.17-7.71C307.36,161.05,291.62,175,303.29,197.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.74,165.12c4.54,6.93,6.61,9.77,5.79,15.67-1.22,8.87-10.72,12.93-17.22,7.49-5.87-4.9-12.31-15.42-7.78-22.9a11.29,11.29,0,0,1,19.21-.26Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.43,185.58s1.12-2.25,5.79-7.31c1.45,2.19,2,4.59-.36,7.19-1,1.43-3.34,1.58-5.14.34A3.15,3.15,0,0,1,306.43,185.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.37,183a5.28,5.28,0,0,0-1.63,3.62,3.45,3.45,0,0,0,2.08-1.15,5.16,5.16,0,0,0,1.63-3.61A3.43,3.43,0,0,0,311.37,183Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59,185.31a1.73,1.73,0,0,0,1.71,0,29.87,29.87,0,0,0,3.63-4.9,1.85,1.85,0,0,0,.06-1.93A45.42,45.42,0,0,0,306.59,185.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.23,178.73a18.88,18.88,0,0,1,.22,5.09,3,3,0,0,0,2.35-.91Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.77,171.79a.35.35,0,0,1-.2,0,3.13,3.13,0,0,0-2.82.47.39.39,0,0,1-.55-.05.37.37,0,0,1,0-.54l0,0a3.93,3.93,0,0,1,3.55-.62.43.43,0,0,1,.28.5A.44.44,0,0,1,304.77,171.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,178.78l-.07,0a.42.42,0,0,1-.42-.38,3.91,3.91,0,0,1,1.42-3.33.39.39,0,0,1,.55.08.42.42,0,0,1-.08.56,3.09,3.09,0,0,0-1.09,2.64A.41.41,0,0,1,295.53,178.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.63,174.54c.4.54.47,1.18.09,1.46s-1,0-1.38-.51-.47-1.17-.09-1.45S305.22,174,305.63,174.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.34,179c.4.54.48,1.18.09,1.46s-1,0-1.36-.51-.48-1.18-.09-1.46S298.94,178.49,299.34,179Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.16,178.44l-1.59.64S298,179.55,298.16,178.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.44,174l-1.58.64S304.28,175.07,304.44,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.2,169.69c3.78,1.49,3.33,11.1,3.33,11.1-.15.37,4.12-5.31,1.72-18.62-1.6-8.87-16.92-11.75-28.24-1.12-2.22,2.07-.89,14.12,0,11.94,1-2.63,7.8-7.65,12-8.73C305.57,164,315,168.81,317.2,169.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.43,162a4.59,4.59,0,0,0,.91-7.32,8.73,8.73,0,0,0-3.74-1.79,11.94,11.94,0,0,1-3.86-1.55c-1.12-.83-1.44-1.87-1.55-3.62a3.81,3.81,0,0,0-1.19,2.75c-1-.75-1.17-1.84-1.56-4.26a5.07,5.07,0,0,0-.51,4.17c-.74-.29-1.22-.82-1.55-3.17-1.23,3-.45,5.63.18,6.07a3.54,3.54,0,0,0-3.44,3,5.13,5.13,0,0,0,1.7,4.46,9.63,9.63,0,0,0,4.43,2.15,17.46,17.46,0,0,0,9.89-.63C316.14,162,316.43,162,316.43,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.86,168a6.11,6.11,0,0,1,.65,4.58c-.54,2.06-2.65,2-4,.54s-2.44-4-1.16-5.6a2.72,2.72,0,0,1,3.83-.39A2.8,2.8,0,0,1,321.86,168Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.37,206.51l-8.69,1.15.12,7.66s5.92-1.29,8.33-4.41Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.61 211.07 296.21 216.73 301.8 215.32 301.68 207.66 296.61 211.07",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M301.26,214.55a.51.51,0,0,0-.15.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,191.88c1.34,5.66,1.05,16.29.87,20.52a8.19,8.19,0,0,1-2.19,5.35c-1.66,1.73-4.46,3-9,1.09s-26.26-6.77-26.21-7.9l.22-4.37s13.17.42,27.3,2c.63-6.61-.64-15-.06-17.23C338.47,187.68,344.87,184.71,346.57,191.88Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.82,182.61c-3,2.2-3.37,18.83-3.37,18.83l15.32.31s0-11.09-1.3-14.34C346.45,182.16,341.18,180.14,337.82,182.61Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.2 405.84 358.4 405.1 357.34 389.12 366.88 388.63 366.2 405.84",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.37 388.82 357.91 397.86 366.54 397.26 367.12 388.54 357.37 388.82",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,402.81l10.19-.69a.88.88,0,0,1,.85.57l2.76,7.91a1.25,1.25,0,0,1-1.13,1.69c-3.58.18-5.29.09-9.81.4-2.76.19-9.86.95-13.67,1.21s-4.77-3.46-3.24-3.91c6.8-2,10.64-4.37,12.64-6.52A2,2,0,0,1,356.83,402.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.71,404.29a.19.19,0,0,0,.14-.19.2.2,0,0,0-.13-.19c-.73-.25-4.35-1.45-5.21-.73a.57.57,0,0,0-.19.58,1.23,1.23,0,0,0,.62.91,3.31,3.31,0,0,0,2,.28A13,13,0,0,0,355.71,404.29Zm-4.55-.93a12.69,12.69,0,0,1,3.82.74c-1.78.54-3.19.63-3.83.24a.83.83,0,0,1-.43-.64.19.19,0,0,1,.06-.2.72.72,0,0,1,.38-.13Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,404.26a.21.21,0,0,0,0-.2c0-.16-1.31-3.73-3.29-3.28-.52.11-.66.39-.63.6,0,1,2.47,2.59,3.67,2.93h.08A.29.29,0,0,0,355.8,404.26Zm-3-3.13c1.25-.13,2.16,1.78,2.52,2.59-1.24-.49-3-1.78-3-2.34,0-.11.1-.21.32-.23l.13,0Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.55 394.54 354.95 395.26 353.33 388.81 370.29 387.71 369.55 394.54",
    style: {
      fill: "#2DAF8E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "184.08 405.23 176.72 403.55 180.35 387.19 190.16 390.58 184.08 405.23",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.43 384.9 181.7 380.67 179.36 391.66 188.45 394.52 192.43 384.9",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.6 405.23 207.13 404.18 210.2 384.85 220.26 387.4 214.6 405.23",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.03 381.54 210.98 378.24 209.26 390.57 218.75 392.25 222.03 381.54",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.11,295.28s-42.55,4.94-44.46,22.53c-1.9,22.93-.79,16.44-6,69.43l12.61.7s12.83-43.34,11.1-60.56c14.13,0,46.48,1.24,51.18-11.51a56.76,56.76,0,0,0,3.35-20.2Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.11,295.28s-42.55,4.94-44.46,22.53c-1.9,22.93-.79,16.44-6,69.43l12.61.7s12.83-43.34,11.1-60.56c14.13,0,46.48,1.24,51.18-11.51a56.76,56.76,0,0,0,3.35-20.2Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "221.56 390.08 207.13 387.61 207.63 380.67 224.13 384.06 221.56 390.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32,400.47l8.42,1.66a.64.64,0,0,1,.48.71l-.7,8a1.4,1.4,0,0,1-1.54,1.31c-2.92-.63-4.3-1.11-8-1.84-2.28-.45-7.49-1.55-10.66-1.9s-2.79-4.06-1.42-4.25c6.16-.82,9.66-1.81,12-3.36A1.85,1.85,0,0,1,207.32,400.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,401.91a9.54,9.54,0,0,0,2,.06.15.15,0,0,0,.15-.11.21.21,0,0,0,0-.19c-.21-.21-2.1-2-3.07-1.8a.62.62,0,0,0-.49.42,1,1,0,0,0,.06,1A2,2,0,0,0,203.54,401.91Zm1.61-.27c-1.39,0-2.37-.16-2.66-.57a.61.61,0,0,1,0-.64.32.32,0,0,1,.23-.22C203.23,400.1,204.37,400.94,205.15,401.64Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.55,402h.08a.2.2,0,0,0,.12-.13c0-.09.55-2.22-.09-3.07a.85.85,0,0,0-.7-.37.67.67,0,0,0-.72.42c-.31.79.55,2.54,1.22,3.11A.11.11,0,0,0,205.55,402Zm-.52-3.21a.51.51,0,0,1,.35.22,4,4,0,0,1,.09,2.46,3.56,3.56,0,0,1-.9-2.49c0-.1.11-.21.37-.2Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.19,295.28c-.33,0-56.2,5.75-56.27,24.7-2.15,14-9.07,67.26-9.07,67.26l11.81,3.86s18.46-37.33,18.17-61.76c15.37-4.41,55.13,3,59.83-9.74,3.85-10.42,1.77-24.32,1.77-24.32Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.35 392.47 177.37 387.88 178.56 381.82 194.17 387.14 191.35 392.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21,399.55l8.44,1.76a.69.69,0,0,1,.47.77l-.66,8.76c-.12,1-.8,1.6-1.53,1.45h0c-2.92-.67-4.3-1.19-8-2-2.28-.47-8.49-2-11.62-2.79s-2.43-4.81-1-4.83c6.19-.09,10.2-1.11,12.58-2.83A1.68,1.68,0,0,1,177.21,399.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.74,401.44a9.83,9.83,0,0,0,1.65-1.13.2.2,0,0,0,.06-.19.18.18,0,0,0-.15-.12c-.29-.05-2.87-.38-3.54.36a.69.69,0,0,0-.14.63,1,1,0,0,0,.64.78A2.1,2.1,0,0,0,173.74,401.44Zm1.13-1.17c-1.09.86-2,1.27-2.47,1.12a.64.64,0,0,1-.39-.52.32.32,0,0,1,.07-.31C172.43,400.21,173.83,400.18,174.87,400.27Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.39,400.31l.07-.06a.15.15,0,0,0,0-.16c0-.07-.88-2.12-1.89-2.43a.86.86,0,0,0-.78.12.67.67,0,0,0-.33.77c.21.82,1.94,1.72,2.83,1.78ZM173.06,398a.52.52,0,0,1,.42,0,4,4,0,0,1,1.54,1.93,3.6,3.6,0,0,1-2.21-1.47c-.06-.08,0-.24.18-.38Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.12,242.05a110.07,110.07,0,0,1,2.16,27.32,8,8,0,0,1-5.35,7.24c-10.69,3.67-38.38,5.06-47.34,3.93l3.63-3.83s38-7.42,37.09-10.39c0,0-1.8-19-3-21.78Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,276.79l-6.44-4.21-6.67,4.52s5.08,4.37,9.87,3.25Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.68,274.05l-3.51,2.71a.39.39,0,0,0,.2.69l4.14.39,5-5.26Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,236.94a5.81,5.81,0,0,1,4.32,7.09c-.34,1.36-11.19,26.72-11.72,27.57-3.58,8.76-9.92,8.18-18.59,8.48-6.88-.08-12,.5-18.74-1l1.65-3.6c4.75-.2,14.82-3.69,20.73-5.35a8,8,0,0,0,5.27-4.12c2.79-6,9.22-21.29,10.14-24.9a5.81,5.81,0,0,1,6.94-4.21Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,275.53l-5.52-2.42-4.63,5.38s7.41,2.36,8.7.1Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,277.63l-1.36,1.28a.48.48,0,0,0,.5.79l3-1.21,4.63-5.38-4.88,3.08A12.33,12.33,0,0,0,189,277.63Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,205.79l5.77,3.59,8.56,4.68a46.56,46.56,0,0,0,.53,6.47c.69,2.72,1.66,4.91,6.46,5.41,0,0,6.25,4.42-4.82,6.1s-14.36-3.3-14.36-3.3C255.61,224,252.12,211.84,249.83,205.79Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.82,194.11c.2.66.71,1.12,1.15,1s.64-.75.44-1.41-.72-1.11-1.16-1S269.62,193.45,269.82,194.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.78,192.6a.36.36,0,0,0,.29-.25,3.42,3.42,0,0,1,2.18-2.07.41.41,0,0,0-.18-.8h0a4.23,4.23,0,0,0-2.76,2.58.42.42,0,0,0,.23.53A.49.49,0,0,0,266.78,192.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.29,194.79a22.37,22.37,0,0,0,3.9,4.4,3.37,3.37,0,0,1-2.66,1.05Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,198.08c2.93,8,4.26,12.93,9.67,16a11.1,11.1,0,0,0,7.78,1.34,11.37,11.37,0,0,0,4.35-1.87h0a11.19,11.19,0,0,0,4.61-9.85C272.74,195.86,268,184,259,182.85a11.25,11.25,0,0,0-12.24,15.23Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,215.4a11.37,11.37,0,0,0,4.35-1.87c-.22.08-3,1.09-4.45.35Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.86,204.75A61.87,61.87,0,0,0,253,216.32c2.82-.85,5.28-1.33,8.16-2,1.12-3.24,1.36-13.39,2.43-15.12s3.25-4,4.19-5.78a8,8,0,0,0-.6-7.91,10.86,10.86,0,0,0-6.83-4.37,15.55,15.55,0,0,0-13.43,3.68,8.46,8.46,0,0,0-3,5C240,192.45,238.86,198.68,242.86,204.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.47,185.71a9.93,9.93,0,0,0,.33,4.09,2.49,2.49,0,0,1-1.76-2.2C242,186.6,242.55,186.11,243.47,185.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,199.86a10,10,0,0,0,4.31,4.52c2.35,1.17,3.35-1,2.55-3.68-.74-2.38-2.81-5.88-5.14-5.92S259.82,197.39,261,199.86Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.78,228.44c-.75-2-4.49-4.37-8-4h-2.33a41.17,41.17,0,0,0-6.09.55,150,150,0,0,0-17,2.86c-2.58.68-5.07,1.54-7,2.28-2-.59-.19,16.86.19,38.31.18,10.19.46,20.26.72,27.2h42.66s-.58-12.89-.46-27.95C286.52,258.65,286.87,236.67,283.78,228.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6,258.24c.32,3.83.65,7.85,1,11.87,4.41-14.44,7.23-28.94,7.23-28.94Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,231.8c-5.49,4.36-10.92,25.7-10.92,25.7l13.08,6.94c4.48-5.83,11.54-18.73,11.59-23.81C253.23,232.82,246.33,227.07,239.34,231.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.85,411.33A4.35,4.35,0,1,1,224.5,407a4.34,4.34,0,0,1,4.35,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,411.33a4.35,4.35,0,1,0,4.35-4.35,4.35,4.35,0,0,0-4.35,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.06,409.94a4.35,4.35,0,1,0,4.35-4.35,4.35,4.35,0,0,0-4.35,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.87,404.49a2,2,0,0,1-2,1.7l-41.67-.62-39,1a2,2,0,0,1-2-1.7,2.12,2.12,0,0,1,1.53-2.48l21.31-4.51a33.7,33.7,0,0,1,6.7-.68h22.9a33.38,33.38,0,0,1,6.69.68l24,4.17A2.11,2.11,0,0,1,303.87,404.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.54,
    y: 358.66,
    width: 15.43,
    height: 38.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.76,
    y: 340.74,
    width: 11,
    height: 17.91,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.76,
    y: 340.74,
    width: 11,
    height: 17.91,
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.76,
    y: 340.74,
    width: 11,
    height: 17.91,
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.76 346 266.76 348.77 266.76 340.74 255.76 340.74 255.76 346",
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.51,
    y: 300.22,
    width: 5.59,
    height: 23.85,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.51,
    y: 300.22,
    width: 5.59,
    height: 23.85,
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.13,340.74V243.82a13.61,13.61,0,0,1,4.65-10.25l7.39-6.47a13.63,13.63,0,0,1,9-3.37h13.59l13,13.88V340.74Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38,320.68h60.9v20.06H202.46a7.21,7.21,0,0,1-6.2-10.87h0A18.72,18.72,0,0,1,212.38,320.68Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.78,237.62V340.75H202.46a7.21,7.21,0,0,1-6.2-10.87,18.71,18.71,0,0,1,16.09-9.19H243a9.11,9.11,0,0,0,9.11-9.11V243.82a13.58,13.58,0,0,1,4.65-10.24l7.39-6.47a13.58,13.58,0,0,1,9-3.37h13.59Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,340.74V243.82a13.64,13.64,0,0,1,4.65-10.25l7.39-6.47a13.63,13.63,0,0,1,9-3.37h7.7a13.63,13.63,0,0,1,9.93,4.29l5.31,5.66a13.6,13.6,0,0,1,3.7,9.33v87.35a10.38,10.38,0,0,1-10.38,10.38Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,340.74V243.82a13.64,13.64,0,0,1,4.65-10.25l7.39-6.47a13.63,13.63,0,0,1,9-3.37h7.7a13.63,13.63,0,0,1,9.93,4.29l5.31,5.66a13.6,13.6,0,0,1,3.7,9.33v87.35a10.38,10.38,0,0,1-10.38,10.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,307.3a57.71,57.71,0,0,0-38,0,5.39,5.39,0,0,1-6.69-2.55h0c-1.14-2.41.39-5.53,3.49-6.62a67.27,67.27,0,0,1,44.38,0c3.1,1.08,4.63,4.21,3.49,6.62h0A5.4,5.4,0,0,1,240.29,307.3Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,307.3a57.71,57.71,0,0,0-38,0,5.39,5.39,0,0,1-6.69-2.55h0c-1.14-2.41.39-5.53,3.49-6.62a67.27,67.27,0,0,1,44.38,0c3.1,1.08,4.63,4.21,3.49,6.62h0A5.4,5.4,0,0,1,240.29,307.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles-2--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--speech-bubbles--inject-120--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311,121.91l27.5-.28a3.73,3.73,0,0,0,3.73-3.67l0-28.21a2.39,2.39,0,0,0,0-.53,3.67,3.67,0,0,0-3.68-3.1l-61.29.37a3.72,3.72,0,0,0-3.72,3.68l0,28.2a2.39,2.39,0,0,0,0,.53,3.67,3.67,0,0,0,3.68,3.1l24.88,0,4.93,15.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.12,139.21l-5.35-16.75-24.51,0a4,4,0,0,1-4.21-4.14l0-28.19a4.25,4.25,0,0,1,4.2-4.18l61.31-.37a4.19,4.19,0,0,1,4.18,3.53,3.12,3.12,0,0,1,0,.61l0,28.2a4.25,4.25,0,0,1-4.21,4.17l-27.13.27Zm-4.62-17.75L307,135.59l3.63-14.18,27.89-.28a3.23,3.23,0,0,0,3.23-3.19l0-28.19a2.33,2.33,0,0,0,0-.46,3.17,3.17,0,0,0-3.17-2.67L277.31,87a3.22,3.22,0,0,0-3.22,3.19l0,28.19a1.75,1.75,0,0,0,0,.46,3.16,3.16,0,0,0,3.16,2.67Z",
    style: {
      fill: "#2DAF8E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 286.64,
    y: 92.15,
    width: 27.66,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.75,
    y: 92.15,
    width: 16.69,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 99.53,
    width: 15.15,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.85,
    y: 99.53,
    width: 36.55,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.22,
    y: 106.91,
    width: 38.5,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.74,
    y: 106.91,
    width: 12.58,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.38,
    y: 114.29,
    width: 10,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik-speech-bubbles-inject-120--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.87,126.43l41.85-.37a3.66,3.66,0,0,1,3.67,3.1,3.23,3.23,0,0,1,0,.53l-.05,28.2a3.73,3.73,0,0,1-3.72,3.68l-26.52.28C357.41,170,348,171.29,348,171.29s5.31-5.39,6.28-9.39l-6.42,0a3.68,3.68,0,0,1-3.68-3.1,4.84,4.84,0,0,1,0-.53l0-28.2A3.73,3.73,0,0,1,347.87,126.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,172l1-1.05c.05-.05,4.68-4.79,6-8.53l-5.75,0a4.17,4.17,0,0,1-4.17-3.53,3.18,3.18,0,0,1,0-.61l0-28.19a4.25,4.25,0,0,1,4.2-4.18h0l41.85-.37a4.1,4.1,0,0,1,4.22,4.14l-.05,28.2a4.25,4.25,0,0,1-4.21,4.17l-26.27.27A24.7,24.7,0,0,1,348,171.78Zm8.3-10.59-.15.62c-.72,3-3.67,6.61-5.31,8.44a23.82,23.82,0,0,0,13.32-8.9l.15-.21,26.77-.28a3.21,3.21,0,0,0,3.23-3.19l.05-28.19a3.44,3.44,0,0,0,0-.46,3.15,3.15,0,0,0-3.16-2.67l-41.86.37a3.22,3.22,0,0,0-3.23,3.19l0,28.19a3.44,3.44,0,0,0,0,.46,3.17,3.17,0,0,0,3.16,2.67Z",
    style: {
      fill: "#2DAF8E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 349.86,
    y: 139.47,
    width: 15.15,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.58,
    y: 132.09,
    width: 27.66,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.79,
    y: 139.47,
    width: 19.38,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.16,
    y: 146.85,
    width: 38.5,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.32,
    y: 154.23,
    width: 10,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles-1--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.87,157.54l-2.42,7.8-3.18-7.94a16,16,0,1,1,5.6.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.51,166.83l-3.6-9a16.52,16.52,0,1,1,6.34.15Zm-.06-40.67a15.53,15.53,0,0,0-3.08,30.75l.27.05,2.75,6.88,2.09-6.75.31-.05a15.53,15.53,0,0,0-2.34-30.88Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.1,139.25c.09-1-.78-1.59-2.05-1.59a3.88,3.88,0,0,0-3.26,1.79l-3.52-2c1.51-2.21,4-3.67,7.69-3.67,3.83,0,6.41,1.63,6.15,4.66-.34,3.88-4.46,4.45-4.66,6.73H255C255.31,141.93,258.94,141.11,259.1,139.25Zm-5,9.88a2.87,2.87,0,0,1,3-2.56,2.36,2.36,0,0,1,2.6,2.56,2.94,2.94,0,0,1-3.05,2.6A2.38,2.38,0,0,1,254.09,149.13Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.61,
    cy: 179.24,
    r: 1.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.61,181.38a2.14,2.14,0,1,1,2.14-2.14A2.14,2.14,0,0,1,234.61,181.38Zm0-3.27a1.14,1.14,0,1,0,1.14,1.13A1.14,1.14,0,0,0,234.61,178.11Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5,173.05a2.72,2.72,0,1,1-4.83,2.41,16,16,0,1,1,4.83-2.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.23,177.76a3.25,3.25,0,0,1-2.84-1.7,16.82,16.82,0,0,1-4.35.58,16.46,16.46,0,1,1,10.11-3.45,3.28,3.28,0,0,1,.3,1.35A3.23,3.23,0,0,1,229.23,177.76ZM227,174.84l.16.45a2.22,2.22,0,1,0,3.94-2l-.26-.39.38-.28a15.52,15.52,0,1,0-4.68,2.33Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,157.44c.09-1-.78-1.59-2.05-1.59a3.88,3.88,0,0,0-3.26,1.79l-3.52-2c1.51-2.21,4-3.67,7.69-3.67,3.83,0,6.41,1.63,6.15,4.66-.34,3.88-4.46,4.45-4.66,6.73h-4.42C219.92,160.12,223.55,159.3,223.71,157.44Zm-5,9.88a2.87,2.87,0,0,1,3-2.56,2.36,2.36,0,0,1,2.6,2.56,2.94,2.94,0,0,1-3.05,2.6A2.38,2.38,0,0,1,218.7,167.32Z",
    style: {
      fill: "#2DAF8E"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternship);
export default __webpack_public_path__ + "static/media/internship.5d3f5388d0f7f118b537cc83489c62ba.svg";
export { ForwardRef as ReactComponent };